import React from "react";
import {HomeNavigation, SearchNavigation} from './Nav';
import {Signin, Settings} from './Account'
import {SearchBar} from './SearchBar'
import {useQuery} from "../utils/router"

export function HomeHeader() {
  return (
    <header className="search-home-header">
      <div style={{visibility: 'hidden'}} className="l-justify center">
        <HomeNavigation />
        <Signin />
      </div>
    </header>
  );
}


export function SearchHeader({fixed}) {
  let query = useQuery();
  const [resource, setResource] = React.useState(query.get("ia") || "news")
  const handleNavLinkClick = (event)=>{
    setResource(event.target.id)
  }
  return (
    <header className="search-header">
      <div className={`topbar ${fixed}`}>
        <SearchBar resource={resource} initQuery={query.get("q")}/>
        {/*<Settings />*/}
      </div>
      <div className="search-ct">
        <SearchNavigation resource={resource} initQuery={query.get("q")} handleNavLinkClick={handleNavLinkClick}/>
      </div>
    </header>
  );
}
